import ImgContainer from "components/common/img";
import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import { getFormattedContactNumber, hasPermission } from "utility/helpers";
import { CellText, StyledEditIcon, StyledTrashIcon } from "assets/js/Styles";
import styled from "styled-components";

const PhotoFrame = styled.div`
  width: 50px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const congressmanColumns = ({
  districts,
  partyList,
  navigate,
  handleDeleteAction,
}) => {
  return [
    {
      name: "",
      selector: null,
      sortable: false,
      id: "highlight",
      width: "5px",
      cell: () => null,
    },
    {
      name: "",
      selector: ({ photo }) => photo,
      grow: 0,
      minWidth: "80px",
      sortable: false,
      style: { paddingTop: "0.5rem", paddingBottom: "0.5rem" },
      cell: ({ photo }) => (
        <PhotoFrame>
          <ImgContainer
            alt="cong-image"
            src={photo}
          />
        </PhotoFrame>
      ),
    },
    {
      name: "Name",
      selector: (row) => row?.fullName,
      identifier: "fullName",
      grow: 2,
      sortable: true,
      cell: ({ fullName }) => <CellText>{fullName}</CellText>,
    },
    {
      name: "Congress",
      selector: (row) => row.is19th || row.is20th,
      identifier: "congress",
      grow: 2,
      sortable: false,
      cell: ({ is19th, is20th }) => {
        let display = "";

        if (is19th && is20th) {
          display = "19th & 20th Congress";
        } else if (is19th) {
          display = "19th Congress";
        } else if (is20th) {
          display = "20th Congress";
        }

        return <CellText>{display}</CellText>;
      },
    },
    {
      name: "District",
      selector: (row) => row?.DistrictId,
      identifier: "DistrictId",
      grow: 2,
      sortable: true,
      cell: ({ DistrictId }) => (
        <CellText>
          {districts.find((district) => district.id === DistrictId)?.name}
        </CellText>
      ),
    },
    {
      name: "Party",
      selector: ({ PartyId }) => PartyId,
      identifier: "PartyId",
      grow: 2,
      sortable: true,
      cell: ({ PartyId }) => (
        <CellText>
          {partyList.find((party) => party.id === PartyId)?.acronym}
        </CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ contact }) => contact,
      identifier: "contact",
      grow: 2,
      sortable: true,
      cell: ({ contact }) => (
        <CellText>{getFormattedContactNumber(contact)}</CellText>
      ),
    },
    {
      name: "COS",
      selector: ({ cosName }) => cosName,
      identifier: "cosName",
      grow: 2,
      sortable: true,
      cell: ({ cosName, cosFirstName, cosLastName }) => (
        <CellText>
          {cosFirstName && cosLastName
            ? `${cosFirstName} ${cosLastName}`
            : cosName || ""}
        </CellText>
      ),
    },
    {
      name: "Contact Info",
      selector: ({ cosContact }) => cosContact,
      identifier: "cosContact",
      grow: 2,
      sortable: true,
      cell: ({ cosContact }) => (
        <CellText>{getFormattedContactNumber(cosContact)}</CellText>
      ),
    },
    {
      name: "Action",
      selector: (row) => row?.id,
      sortable: false,
      width: "100px",
      style: { cursor: "pointer" },
      center: true,
      id: "action",
      cell: (row) => (
        <>
          {hasPermission("congressman-update") && (
            <>
              <StyledEditIcon
                size={16}
                id={`edit-row--${row.id}`}
                onClick={() => {
                  navigate("/cong", {
                    state: {
                      cong: row,
                    },
                  });
                }}
              />
              <UncontrolledTooltip
                placement="auto"
                target={`edit-row--${row.id}`}
              >
                {"Edit"}
              </UncontrolledTooltip>
            </>
          )}

          {hasPermission("congressman-delete") && (
            <>
              <StyledTrashIcon
                size={16}
                id={`delete-row--${row.id}`}
                onClick={() => handleDeleteAction(row)}
              />
              <UncontrolledTooltip
                placement="right"
                target={`delete-row--${row.id}`}
              >
                {"Delete"}
              </UncontrolledTooltip>
            </>
          )}
        </>
      ),
    },
  ];
};

export default congressmanColumns;
